export const packageQueryKeys = {
  all: ['package'] as const,
  lists: () => [...packageQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...packageQueryKeys.lists(), filters] as const,
  details: () => [...packageQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...packageQueryKeys.details(), id] as const,
};
